import { render, staticRenderFns } from "./KDialogSimple.vue?vue&type=template&id=7de5b605"
import script from "./KDialogSimple.vue?vue&type=script&lang=js"
export * from "./KDialogSimple.vue?vue&type=script&lang=js"
import style0 from "./KDialogSimple.vue?vue&type=style&index=0&id=7de5b605&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports